<template>
  <div>
    <table-filter
      v-if="filterConfig"
      :config="filterConfig"
      action="customRepresentativePriceList/fetchAll"
    />
    <div v-loading="loading">
      <el-table
        v-if="priceLists && priceLists.data"
        :data="priceLists.data"
        style="width: 100%"
        :row-class-name="'pointer-row'">

      <!--        @row-click="(row) => $router.replace('/representative-processes/representative-prices/custom/view/' + row.id)"-->
        <el-table-column
          prop="name"
          label="Megnevezés"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.name }}
            </div>
            <el-tag
              v-if="isValid(scope.row.from, scope.row.to) && scope.row.is_active"
              style="margin-top: 5px;"
              size="mini"
              type="success"
            >
              Aktív és érvényes
            </el-tag>
            <el-tag
              v-if="!isValid(scope.row.from, scope.row.to) && scope.row.is_active"
              style="margin-top: 5px;"
              size="mini"
              type="warning"
            >
              Aktív és érvénytelen
            </el-tag>
            <el-tag
              v-if="isValid(scope.row.from, scope.row.to) && !scope.row.is_active"
              style="margin-top: 5px;"
              size="mini"
              type="warning"
            >
              Inaktív és érvényes
            </el-tag>
            <el-tag
              v-if="!isValid(scope.row.from, scope.row.to) && !scope.row.is_active"
              style="margin-top: 5px;"
              size="mini"
              type="danger"
            >
              Inaktív és érvénytelen
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="Hozzárendelés típusa"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.type === 'partner'"
            >
              <el-tag
                size="mini"
                type="info"
              >
                Partnerhez rendelt
              </el-tag>
              <div style="margin-top: 5px;">
                <strong>#{{ scope.row.partner_id }}</strong> {{ scope.row.partner_name }}
              </div>
            </div>
            <div
              v-if="scope.row.type === 'group'"
            >
              <el-tag
                size="mini"
                type="info"
              >
                Csoporthoz rendelt
              </el-tag>
              <div style="margin-top: 5px;">
                <strong>#{{ scope.row.customer_group_id }}</strong> {{ scope.row.customer_group_name }}
              </div>
            </div>
            <div
              v-if="scope.row.type === 'shop'"
            >
              <el-tag
                size="mini"
                type="info"
              >
                Üzlethez rendelt
              </el-tag>
              <div style="margin-top: 5px;">
                <strong>#{{ scope.row.shop_id }}</strong> {{ scope.row.shop_name }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="valid"
          label="Érvényesség"
        >
          <template slot-scope="scope">
            <div style="margin-bottom: 5px;">
              <span v-if="scope.row.from">{{ scope.row.from | date }}</span><span v-else>∞</span> -
              <span v-if="scope.row.to">{{ scope.row.to | date }}</span><span v-else>∞</span>
            </div>
            <div>
              <el-tag
                v-if="isValid(scope.row.from, scope.row.to)"
                size="mini"
                type="success"
              >
                Érvényes
              </el-tag>
              <el-tag
                v-if="!isValid(scope.row.from, scope.row.to)"
                size="mini"
                type="danger"
              >
                Érvénytelen
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="items_count"
          label="Termékek száma"
          width="150"
        >
          <template slot-scope="scope">
            <el-tag
              size="small"
              type="primary"
            >
              {{ scope.row.items_count }} termék
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label=""
          width="220"
          style="text-align: right;"
        >
          <template
            slot-scope="scope"
          >
            <Actions :price="scope.row"/>
          </template>
        </el-table-column>
      </el-table>
      <div class="el-card-footer">
        <el-pagination
          v-if="priceLists"
          background
          :current-page.sync="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="priceLists.per_page"
          layout="total, prev, pager, next"
          :total="priceLists.total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import TableFilter from '../../TableFilter';
import Actions from './Actions';
import moment from 'moment';

export default {
  components: {
    TableFilter,
    Actions
  },
  data() {
    return {
      filterConfig: null,
      currentPage: 1,
    };
  },
  computed: {
    loading() {
      return this.$store.getters['customRepresentativePriceList/loading'];
    },
    priceLists() {
      return this.$store.getters['customRepresentativePriceList/customRepresentativePriceLists'];
    }
  },
  async mounted() {
    this.$store.commit('customRepresentativePriceList/setFilterString', '');
    this.$store.commit('customRepresentativePriceList/setCurrentPage', this.currentPage);
    this.setConfig();
    await this.$store.dispatch('customRepresentativePriceList/fetchAll');
  },
  methods: {
    isValid(validFrom, validTo) {
      const from = moment(validFrom);
      const to = moment(validTo);
      return (validFrom === null && validTo === null)
        || (validFrom === null && to.isSameOrAfter(moment()))
        || (validTo === null && from.isSameOrBefore(moment()))
        || (to.isSameOrAfter(moment()) && from.isSameOrBefore(moment()));
    },
    setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'name',
          label: 'Megnevezés',
          defaultSearch: true,
        },
        {
          type: 'remote',
          name: 'partner',
          label: 'Partner',
          labelCallback: partner => partner && partner.company && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'remote',
          name: 'shop_id',
          label: 'Üzlet',
          labelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'shop/search',
        },
        {
          type: 'multipleRemoteSelect',
          name: 'product_id',
          label: 'Termék(ek)',
          labelCallback: product => product && `#${product.id} ${product.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'product/search',
        },
        {
          type: 'select',
          name: 'is_active',
          options: [
            {
              label: 'Aktív',
              status: 1,
            },
            {
              label: 'Inaktív',
              status: 0,
            },
          ],
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          name: 'is_valid',
          options: [
            {
              label: 'Igen',
              status: 1,
            },
            {
              label: 'Nem',
              status: 0,
            },
          ],
          label: 'Érvényes',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
      ];
    },
    handleCurrentChange(val) {
      this.$store.commit('customRepresentativePriceList/setCurrentPage', val);
      this.$store.dispatch('customRepresentativePriceList/fetchAll');
    },
  }
};
</script>

<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
